/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBinoculars = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m22 16-.4-4.6-.5-3.3-.4-2.8C20.5 3.4 18.8 2 16.9 2c-1.7 0-3.3 1.1-3.8 2.7-.1.4-.1.7-.1 1V7h-2V5.7c0-.3 0-.6-.1-.9-.5-1.7-2-2.8-3.8-2.8-2 0-3.6 1.4-3.9 3.3l-.8 6.2-.4 4.6v1.4C2 20 4 22 6.5 22s4.5-2 4.5-4.5V15h2v2.5c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5zM4.4 11.7l.8-6.1c.1-.9 1-1.6 1.9-1.6s1.6.5 1.9 1.3v8.5c-.7-.5-1.6-.8-2.5-.8-.8 0-1.6.2-2.3.6zM6.5 20C5.1 20 4 18.9 4 17.5S5.1 15 6.5 15 9 16.1 9 17.5 7.9 20 6.5 20zM15 5.7v-.4c.3-.8 1-1.3 1.9-1.3 1 0 1.8.7 1.9 1.5l.4 2.8.5 3.2.2 2c-.7-.4-1.4-.6-2.3-.6s-1.8.3-2.5.8v-8zM11 13V9h2v4zm6.5 7c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgBinoculars as Binoculars };
